import { Eye, EyeClosed } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "../shadcn/tooltip";
import { useLicensesOverview } from "../../views/Licenses/LicensesOverview/LicensesOverview";
import { cn } from "../../lib/utils";

export const HidePrices = ({ ...props }) => {
   const { hidePrices, updateHidePrices } = useLicensesOverview();

   function toggleHidePrices() {
      updateHidePrices(!hidePrices);
   }

   return (
      <Tooltip>
         <TooltipTrigger asChild>
            <button
               onClick={toggleHidePrices}
               className={cn(`flex items-center border! border-(--borderColor)! justify-center size-8 rounded-(--borderRadius)! text-(--textColor)! hover:bg-(--borderColor)! transition-colors`, props.className)}
               aria-label="Alternar visibilidade do faturamento"
            >
               <span>
                  {hidePrices ? (<EyeClosed size={18} />) : (<Eye size={18} />)}
               </span>
            </button>
         </TooltipTrigger>
         <TooltipContent>
            <p className="font-medium">{hidePrices ? `Mostrar faturamento` : `Esconder faturamento`}</p>
         </TooltipContent>
      </Tooltip>
   );
}